if (!customElements.get('nuxero-visual-options')) {
  customElements.define('nuxero-visual-options', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const start = () => {
        if (!this.isConnected) return;
        this.offer = document.getElementById('NuxeroVisionSyncOffer');
        this.pair = this.offer?.querySelector('[data-pair="1"]');
        if (!this.pair) return;
        this.radios = [...this.querySelectorAll('[data-nx-option]')];
        this.sync = () => {
          const selected = [...this.pair.querySelectorAll('[data-option]')].map(s => s.value);
          this.radios.forEach(radio => {
            const index = Number(radio.dataset.nxOption);
            radio.checked = radio.value === selected[index];
            radio.disabled = this.offer.locked || !this.offer.variants.some(v => v.available && v.options.every((value, i) => value === (i === index ? radio.value : selected[i])));
          });
        };
        this.addEventListener('change', event => {
          const radio = event.target.closest('[data-nx-option]');
          if (!radio || this.offer.locked) return;
          const select = this.pair.querySelector(`[data-option="${radio.dataset.nxOption}"]`);
          select.value = radio.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          const variant = this.offer.selection(this.pair);
          if (variant) {
            const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
            this.offer.querySelector('input[name="id"]').value = variant.id;
          }
          this.sync();
        }, { signal: this.abort.signal });
        this.offer.addEventListener('change', this.sync, { signal: this.abort.signal });
        this.observer = new MutationObserver(this.sync);
        this.observer.observe(this.pair, { subtree: true, attributes: true, attributeFilter: ['disabled'] });
        this.sync();
      };
      customElements.whenDefined('nuxero-bundle').then(start);
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
  });
}
